import Navbar from '@/components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import InfoSection from './components/InfoSection';
import FeaturesSection from './components/FeaturesSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const siteUrl = 'https://basetaosheet.mom';
const faviconUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c3d9.png';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'BaseTao Spreadsheet Guide',
  url: siteUrl,
  description: 'The most comprehensive BaseTao Spreadsheet resource online. Honest reviews, shipping cost breakdowns, discount codes, warehouse guides, and expert tutorials.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/guides?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'BaseTao Spreadsheet Guide',
  url: siteUrl,
  logo: {
    '@type': 'ImageObject',
    url: faviconUrl,
  },
  description: 'Independent educational resource providing honest BaseTao Spreadsheet reviews, shipping guides, warehouse information, and expert tutorials.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <InfoSection />
        <FeaturesSection />
        <ArticleSection />
        <CTASection />
        <FooterSection />
      </main>
    </>
  );
}